import { Navigate, useLocation } from "react-router";
export default function NoWin() {
  const { state } = useLocation();

  if (!state?.redirected) {
    return <Navigate to="/" />;
  }
  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">Sorry</h1>
      <h2 className="text-red mx-auto mb-4 max-w-xs text-center font-bold">
        You’re not a winner this time, but there are more chances to win every
        day. {" "}
      </h2>
      <p className="text-red mx-auto max-w-xs text-center">
        Head to your local store for another Costa Express coffee tomorrow and
        enter here to try again. {" "}
      </p>
    </div>
  );
}
